import axios from "axios";
import { ApiPathRESE } from "../../../common/api-path/ApiPath";

export const getReseStoreTableData = async (pageNumber, pageSize, sortBy, sortDirection, filterCondition) => {
    const requestConfig = {
        params: {pageNumber, pageSize, sortBy, sortDirection, filterCondition}
    }
    const response = await axios.get(`${ApiPathRESE.baseUrl}/getStore`,requestConfig);
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return response.data;
};

export const getReseStoreTableDistinctColumnData = async (columnPayload) => {
    const response = await axios.post(`${ApiPathRESE.baseUrl}/getDistinctColumnValue`, columnPayload, { timeout: 120000, timeoutErrorMessage: "request timeout" });
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return response.data;
}

export const updateReseStoreTableData = async (tableData) => {
    const response = await axios.put(`${ApiPathRESE.baseUrl}/updateStore`, tableData, { timeout: 120000, timeoutErrorMessage: "request timeout" });
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return response.data;
}